
import React from "react";
import PostContent from "@/components/blog/PostContent";

interface EditorContentProps {
  isFullScreen: boolean;
  showPreview: boolean;
  value: string;
  onChange: (value: string) => void;
  theme: string;
}

const EditorContent: React.FC<EditorContentProps> = ({
  isFullScreen,
  showPreview,
  value,
  onChange,
  theme
}) => {
  if (isFullScreen && showPreview) {
    return (
      <div className="flex h-full">
        <div className="w-1/2 h-full border-r">
          <textarea
            id="html-editor"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="w-full h-full p-4 font-mono text-sm resize-none focus:outline-none"
            spellCheck={false}
            placeholder="Enter HTML content here..."
          />
        </div>
        <div className="w-1/2 h-full">
          <div className="w-full overflow-hidden h-full">
            <div className="p-4 h-full overflow-auto">
              <PostContent content={value} theme={theme} />
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <textarea
        id="html-editor"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full h-full p-4 font-mono text-sm resize-none focus:outline-none"
        spellCheck={false}
        placeholder="Enter HTML content here..."
      />
    );
  }
};

export default EditorContent;
